import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getTaxonomyDetails, getTaxonomyList } from '../API/taxonomyApi';
import type { RootState } from '../store/store';
import { v4 as uuidv4 } from 'uuid';

interface TaxonomyState {
  taxonomyList: any[],
  taxonomyDetail: TaxonomyDetail,
}

export interface TaxonomyNode {
  id: string,
  level: number,
  node: string,
  parent: string,
  relationship: string,
  description: string,
  references: string
}

interface TaxonomyDetail {
  nodes: TaxonomyNode[]
}

export const initialTaxonomyNode = {
  id: uuidv4(),
  level: 0,
  node: 'Primary Node',
  parent: '',
  description: '',
  relationship: '',
  references: ''
}

// Define the initial state using that type
const initialState: TaxonomyState = {
    taxonomyList: [],
    taxonomyDetail: {
      nodes: [
        { ...initialTaxonomyNode }
      ]
    }
};

export const callGetTaxonomyList = createAsyncThunk(
    'taxonomy/getTaxonomyList',
    async (args, { dispatch }) => {
        const response = await getTaxonomyList();
        dispatch(setTaxonomyList(response.data.data));
    }
)

export const callGetTaxonomyDetails = createAsyncThunk(
    'taxonomy/getTaxonomyDetail',
    async (taxonomyId: string, { dispatch }) => {
        const response = await getTaxonomyDetails(taxonomyId);
        dispatch(setTaxonomyDetails(response.data));
    }
)

export const taxonomySlice = createSlice({
  name: 'taxonomy',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setTaxonomyList: (state, action: PayloadAction<any[]>) => {
      state.taxonomyList = action.payload;
    },
    setTaxonomyDetails: (state, action: PayloadAction<any>) => {
        state.taxonomyDetail = action.payload;
    }
  }
});

export const {
    setTaxonomyList,
    setTaxonomyDetails
} = taxonomySlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectTaxonomyList = (state: RootState): any[] => state.taxonomy.taxonomyList;
export const selectTaxonomyDetail = (state: RootState): TaxonomyDetail => state.taxonomy.taxonomyDetail;

export default taxonomySlice.reducer;
